var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import lodash from 'lodash';
import { Bind, Debounce } from 'lodash-decorators';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Component, Inject, Mixins } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    get readonlyText() {
        // if (lodash.isArray(this.value)) {
        //   const filters = lodash.filter(this.dataSource, item => lodash.includes(this.value, String(item.value)));
        //   return lodash.map(filters, 'label').join(' / ')
        // }
        this.$message;
        const filters = lodash.filter(this.dataSource, (item) => lodash.includes(this.value, item.value));
        return lodash.map(filters, 'label').join(' / ');
    }
    // 加载数据源
    async onRequest(value) {
        this.spinning = true;
        const startTime = Date.now();
        try {
            const { _request } = this;
            let res = [];
            if (lodash.isFunction(_request)) {
                res = await _request(value);
            }
            else if (lodash.isArray(_request)) {
                res = _request;
            }
            this.dataSource = res;
        }
        catch (error) {
            console.error('LENG ~ onRequest', error);
        }
        if (this.dataSource.length > 0) {
            const endTime = Date.now();
            const diffTime = 400 - (endTime - startTime);
            // 保证动画最少500考秒
            await of(1)
                .pipe(delay(diffTime > 0 ? diffTime : 0))
                .toPromise();
        }
        this.spinning = false;
    }
    onSearch(value) {
        console.log(value, 'regionalSupervisorName');
        this.onRequest(value);
    }
    async mounted() {
        this.onLinkage();
        if (this.debug) {
            console.log('');
            console.group(`Field ~ ${this.entityKey} ${this._name} `);
            console.log(this);
            console.groupEnd();
        }
    }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Inject({ default: '' })
], default_1.prototype, "formType", void 0);
__decorate([
    Bind(),
    Debounce(600)
], default_1.prototype, "onSearch", null);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
